<div class="container-fluid navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
  <div class="row">
    <div class="col-2">
      <img [src]="logoUrl" class="logo-width app-logo" alt="Logo"/>
    </div>
    <div [ngClass]="environmentType?.trim().length > 0 && environment !== 'prod' && environmentTypeAvailable ? 'col-5 pr-0' : 'col-8 pr-0'">
      <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3 mt-1"  (click)="onClickSidebarToggle()" aria-label="Toggle">
        <i class="fa fa-bars"></i>
        <i class="fa fa-navicon"></i>
      </button>
      <div class="breadcrumb-new breadcrumb-alingment">
        <a class="breadcrumb-new-item" style="pointer-events: none" [routerLink]="breadcrumbPrefixUrl"> {{breadcrumbPrefixLabel}} </a>
        <i class="fa fa-angle-double-right"></i>
        <ng-container *ngIf="isComponentEntityDisplayed()">
          <a class="breadcrumb-new-item" (click)="onClickChield()" [routerLink]="'/' + getDefaultRoute()">
            {{ getComponentEntityLabel() }}
          </a>
          <i class="fa fa-angle-double-right"></i>
        </ng-container>
        <!-- <a [routerLink]="breadcrumbPrefixUrl">
          {{ breadcrumbLabel }}
        </a> -->
        <span class="current" style="cursor:pointer;"> {{ breadcrumbLabel }}</span>
      </div>
      <!-- <div style="float: inline-end; font-size: 0.8rem;
      font-weight: 600; color: #041F55;
      margin-top: 7px;">{{ currentDateAndTime }}</div> -->
    </div>
    <ng-container *ngIf="environmentType?.trim().length > 0 && environment !== 'prod' && environmentTypeAvailable">
      <div class="col-3 mt-1">
        <span class="TextOverflowDetail" [style.border]="environmentType?.trim().length ? '1px solid' : 'none'"
          [style.padding]="environmentType?.trim().length ? '5px' : '0'" [style.color]="environmentTypeColor" style="font-weight: 600;">
          {{ environmentType }}
        </span>
      </div>
    </ng-container>
    <div class="col-2 TopUserSpace pl-0">
      <div class="text-right">
        <div class="dropdown">
          <a class="dropdown-toggle iPadProFontSize iPadProFontSize" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true"
            aria-expanded="false" href="">
            <i class="fa fa-user-circle mr-2"></i>Hi, {{ userName }}
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div *ngIf="showHomeMenu()" class="dropdown-item" style="cursor: pointer">
              <a routerLink="{{getRedPath()}}" class="pl-0" style="color: #4e73df; display: block; width: 100%!important; ">Home</a>
            </div>
            <div class="dropdown-item" style="cursor: pointer">
              <a routerLink="../user-guide" target="_blank" class="pl-0" style="color: #4e73df">Klear.ai Help</a>
            </div>
            <div class="dropdown-item" style="cursor: pointer">
              <a routerLink="/support" target="_blank" class="pl-0" style="color: #4e73df">Klear.ai Support</a>
            </div>
            <div class="dropdown-item" style="cursor: pointer;color: #4e73df;" (click)="logout()">
              Logout
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>